import ApiService from "@/common/api.service"

export const MenuItemService = {
    create(params) {
        return ApiService.post("menuItems/add", params);
    },
    update(slug, params) {
        return ApiService.update("menuItems", slug, params);
    },
    delete(slug, params) {
        return ApiService.delete("menuItems/delete", slug, params)
    },
    async getMenuItems() {
        const res = await ApiService.get("/menuItems");
        return res.data;
    },
    async getMenuItemsWP(page, itemsPerPage, name) {
        const res = await ApiService.get(
            `/menuItems?page=${page}&pageSize=${itemsPerPage}&name=${name}`
        );
        return res.data;
    }

}